import { render, staticRenderFns } from "./SetCardPriorityModal.vue?vue&type=template&id=02a259fc&"
import script from "./SetCardPriorityModal.vue?vue&type=script&lang=js&"
export * from "./SetCardPriorityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports